/**
 * Por qué se devuelve un gasto al conductor para que lo corrija.
 *
 * Catálogo **cerrado**, a diferencia de las categorías de gasto: éstas las elige
 * operaciones desde esta pantalla, no crecen solas desde la app del conductor, y
 * el backend rechaza con `InvalidReasonCode` cualquier valor que no esté aquí.
 *
 * Se guarda el código y no el texto para que el conductor lea el motivo **en su
 * idioma**: una frase escrita a mano se queda congelada en el idioma de quien la
 * escribió, y operaciones y conductor no siempre trabajan en el mismo.
 *
 * Sólo aplica a la devolución. El rechazo definitivo se explica con texto libre,
 * porque sus motivos son de otra naturaleza.
 */
export type ExpenseReturnReason =
  | 'blurry-photo'
  | 'missing-photo'
  | 'wrong-photo'
  | 'wrong-amount'
  | 'wrong-category'
  | 'wrong-date';

/** Motivos en el orden en que se ofrecen. */
export const EXPENSE_RETURN_REASONS: readonly ExpenseReturnReason[] = [
  'blurry-photo',
  'missing-photo',
  'wrong-photo',
  'wrong-amount',
  'wrong-category',
  'wrong-date',
] as const;

export function isExpenseReturnReason(
  value: unknown
): value is ExpenseReturnReason {
  return EXPENSE_RETURN_REASONS.includes(value as ExpenseReturnReason);
}
